export default {
  templates: {
    // Traditional Wedding Tasks
    'choose-venue': {
      title: 'Scegliere il luogo della reception',
      description: 'Ricercare e visitare diversi luoghi per la cerimonia e la reception'
    },
    'define-budget': {
      title: 'Definire il budget complessivo',
      description: 'Stabilire un budget dettagliato per ogni voce di spesa'
    },
    'choose-date': {
      title: 'Scegliere la data',
      description: 'Fissare la data del matrimonio in base alla disponibilità del luogo e dei fornitori principali'
    },
    'book-venue': {
      title: 'Prenotare il luogo della reception',
      description: 'Visitare e prenotare il luogo per la cerimonia e la reception'
    },
    'choose-photographer': {
      title: 'Scegliere il fotografo',
      description: 'Ricercare e incontrare fotografi per selezionare quello per il vostro matrimonio'
    },
    'choose-caterer': {
      title: 'Scegliere il catering',
      description: 'Ricercare e selezionare un catering per la reception'
    },
    'choose-florist': {
      title: 'Scegliere il fiorista',
      description: 'Selezionare un fiorista per le decorazioni della cerimonia e reception'
    },
    'choose-music': {
      title: 'Scegliere la musica',
      description: 'Selezionare musicisti o DJ per la cerimonia e la reception'
    },
    'choose-transport': {
      title: 'Scegliere il trasporto',
      description: 'Prenotare il trasporto per il giorno del matrimonio'
    },
    'choose-attire': {
      title: 'Scegliere l\'abbigliamento',
      description: 'Acquistare l\'abito da sposa e il completo dello sposo'
    },
    'choose-beauty': {
      title: 'Scegliere i servizi di bellezza',
      description: 'Prenotare servizi di acconciatura e trucco per il giorno del matrimonio'
    },
    'send-invitations': {
      title: 'Inviare gli inviti',
      description: 'Progettare e inviare inviti di matrimonio agli ospiti'
    },
    'plan-honeymoon': {
      title: 'Pianificare la luna di miele',
      description: 'Ricercare e prenotare destinazione per la luna di miele'
    },
    'legal-formalities': {
      title: 'Formalità legali',
      description: 'Completare tutti i requisiti legali per il matrimonio'
    }
  }
};
